import { CSSObject, Sx } from '@mantine/core';
import { Elevation2 } from '@services/mantine';
import { zIndexes } from '@styles/zindex/zindex';
import styled from 'styled-components';

export const Button = styled.a`
  border: 0;
  background-color: transparent;
  text-align: left;

  transition: 0.2s;

  :hover {
    border-radius: 4px;
    background-color: #edeff4;
  }
`;
export const pSx: CSSObject = {
  margin: 0,
};

export const gridSx: CSSObject = {
  paddingLeft: 24,
};
export const stackSx: CSSObject = {
  padding: '8px 18px 8px 4px',
};
export const helpMenuStack: Sx = () => {
  return {
    padding: '16px 16px 24px 16px',
    width: 380,
    ...Elevation2,
    borderRadius: 8,
    position: 'relative',
    zIndex: zIndexes.indexOf('overlay-menu'),
  };
};
